import { PropsWithChildren } from 'react'
import styles from '../SimulationLayouts.module.scss'
import classNames from 'classnames'
import { SimulationSteps } from 'features/simulation/types'
import { useTranslation } from 'next-i18next/pages'
import { useRouter } from 'next/router'
import { routes } from 'utils/routes'
import { useStoreSelector } from 'hooks/store'
import PageFlag from 'components/page-flag/PageFlag'
import { SimulationLayoutProps } from 'features/simulation/layouts/simulation-layout/types'
import Seo from 'components/seo/Seo'
import FlowHeader from 'components/flow-header/FlowHeader'
import { CustomerFlows } from 'store/customer/enums'

const SimulationLayout = ({ children, fullWidth }: PropsWithChildren<SimulationLayoutProps>) => {
  // REDUX STORE
  const { currentStep } = useStoreSelector((store) => store.customer.flows.simulation)

  // i18n
  const { t } = useTranslation(['simulationCard', 'simulation', 'common'])

  // Router
  const router = useRouter()
  const { locale } = router

  return (
    <>
      <Seo title={t('simulation:seo.title')} />

      <PageFlag onClick={() => router.push(routes(locale).home)} />

      <div className={styles.simulation}>
        <FlowHeader flow={CustomerFlows.SIMULATION} />

        <main
          className={classNames(styles.content, {
            [styles['is-full-width']]: fullWidth,
            [styles['is-proposition-step']]: currentStep === SimulationSteps.PROPOSITION
          })}
        >
          {children}
        </main>
      </div>
    </>
  )
}

export default SimulationLayout
